import { InfoPage } from "@shared/praxis-config";
import { routes } from "../../routing/routes";

export const infoPageRoute = (id: string) =>
  `${routes.questionnaire.info}/${id}`;

export const routeOfInfoPageOrSend = (infoPages: InfoPage[], index: number) =>
  index < infoPages.length
    ? infoPageRoute(infoPages[index].id)
    : routes.questionnaire.send;
